import { createReducer, on } from '@ngrx/store';
import * as ExpenseTypeActions from './expense-type.actions';
import { ExpenseType } from './expense-type.models';

// ----------------------------------------------------------------------
// @ States
// ----------------------------------------------------------------------

export interface ExpenseTypesState {
    expenseTypes: ExpenseType[];
    expenseType: ExpenseType;
    isLoading: boolean;
    error: string | null;
}

// ----------------------------------------------------------------------
// @ Initial States
// ----------------------------------------------------------------------

export const initialExpenseTypesState: ExpenseTypesState = {
    expenseTypes: [],
    expenseType: null,
    isLoading: false,
    error: null,
};

// ----------------------------------------------------------------------
// @ Reducers
// ----------------------------------------------------------------------

// All Expense Types Reducer
export const expenseTypesReducer = createReducer(
    initialExpenseTypesState,

    // On Load ExpenseTypes
    on(ExpenseTypeActions.loadExpenseTypes, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(
        ExpenseTypeActions.loadExpenseTypesSuccess,
        (state, { expenseTypes }) => ({
            ...state,
            isLoading: false,
            expenseTypes: expenseTypes,
        })
    ),
    on(ExpenseTypeActions.loadExpenseTypesFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Load Single ExpenseType
    on(ExpenseTypeActions.loadExpenseType, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(ExpenseTypeActions.loadExpenseTypeSuccess, (state, { expenseType }) => ({
        ...state,
        isLoading: false,
        expenseType: expenseType,
    })),
    on(ExpenseTypeActions.loadExpenseTypeFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Create
    on(ExpenseTypeActions.createExpenseType, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(
        ExpenseTypeActions.createExpenseTypeSuccess,
        (state, { expenseType }) => ({
            ...state,
            isLoading: false,
            expenseTypes: [...state.expenseTypes, expenseType],
        })
    ),
    on(ExpenseTypeActions.createExpenseTypeFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Update
    on(ExpenseTypeActions.updateExpenseType, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(
        ExpenseTypeActions.updateExpenseTypeSuccess,
        (state, { expenseType }) => ({
            ...state,
            isLoading: false,
            expenseTypes: state.expenseTypes.map((t) =>
                t.id === expenseType.id ? expenseType : t
            ),
        })
    ),
    on(ExpenseTypeActions.updateExpenseTypeFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Delete
    on(ExpenseTypeActions.deleteExpenseType, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(ExpenseTypeActions.deleteExpenseTypeSuccess, (state, { id }) => ({
        ...state,
        isLoading: false,
        expenseTypes: state.expenseTypes.filter((t) => t.id !== id),
    })),
    on(ExpenseTypeActions.deleteExpenseTypeFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    }))
);
